import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  Grid,
  Typography,
  IconButton,
  CircularProgress,
  Box,
} from '@mui/material'
import closeIcon from 'src/assets/icons/closeIcon.png'
type ConfirmationBoxProps = {
  open: boolean
  title?: string
  onAccept: () => void
  onReject: () => void
}
const ConfirmationBox = ({ open, title, onAccept, onReject }: ConfirmationBoxProps) => {
  return (
    <Dialog maxWidth='xs' fullWidth open={open} disableEscapeKeyDown>
      <Box p={2}>
        <DialogTitle>
          {title && (
            <Typography variant='h3' textAlign='center' color='black'>
              {title}
            </Typography>
          )}
        </DialogTitle>

        <Box p={2}>
          <Box>
            <Button fullWidth type='button' variant='contained' color='primary' onClick={onAccept}>
              Yes
            </Button>
          </Box>
          <Box mt={2}>
            <Button type='button' variant='outlined' color='primary' fullWidth onClick={onReject}>
              No
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  )
}

export default ConfirmationBox
